import React from 'react';

const SvgSuccess = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm5.087 7.24a1.326 1.326 0 00-1.846.323l-4.637 6.594-2.266-2.687a1.326 1.326 0 00-2.026 1.709l3.375 4a1.327 1.327 0 002.097-.092l5.625-8a1.325 1.325 0 00-.322-1.846z",
  fillRule: "evenodd"
}));

export default SvgSuccess;